import { render, staticRenderFns } from "./CurrentLeftMenuAction.vue?vue&type=template&id=606cfda0"
import script from "./CurrentLeftMenuAction.vue?vue&type=script&lang=js"
export * from "./CurrentLeftMenuAction.vue?vue&type=script&lang=js"
import style0 from "./CurrentLeftMenuAction.vue?vue&type=style&index=0&id=606cfda0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports